import { Sender } from 'xstate';
import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';

import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { UserInterpreter } from '../user.xstate';
import { globalAppService } from '../app.xstate';
import { GLOBAL_APP_SUB_MACHINE_IDS } from '../app.xstate-utils';
import { checkForErrors, extractUserProjects, UserProject } from '../../utils';

let hasUpdateUserInfoSubRun = false;

export const getUserData =
  (ctx: ProStudioContext, _event: ProStudioEvents) =>
  async (sendEvent: Sender<ProStudioEvents>) => {
    const userService = globalAppService.children.get(
      GLOBAL_APP_SUB_MACHINE_IDS.user
    ) as UserInterpreter;

    const userServiceSubscription = userService?.subscribe(async (state) => {
      const userContext = state?.context;

      const userId = userContext?.user?.id;

      if (!userId) return;

      if (hasUpdateUserInfoSubRun === false) {
        hasUpdateUserInfoSubRun = true;
        const defaultOrgId = userContext?.user?.defaultAccount?.defaultOrgId;
        const email = userContext?.user?.email;
        const status = userContext?.user?.status;
        const firstName = userContext?.user?.firstName;
        const lastName = userContext?.user?.lastName;

        const userProjectsResponse = await urqlGql.getUserProjects({ userId });

        checkForErrors(userProjectsResponse);

        const userProjects = extractUserProjects(
          userProjectsResponse.data?.tenancy_users[0]
        );

        const nextUserInfoState: ProStudioContext['userInfo'] & {
          userProjects: UserProject[];
        } = {
          ...ctx.userInfo,
          id: userId,
          defaultOrgId,
          email,
          userProjects,
          status,
          firstName,
          lastName,
        };

        sendEvent({
          type: 'updateUserInfo',
          data: nextUserInfoState,
        });
      }
    });

    if (hasUpdateUserInfoSubRun) {
      userServiceSubscription.unsubscribe();
    }
  };
